export function StyleFormatPainter (pEditor, pStyle)
{
  var copyTextStyle = pEditor.pParent.copyTextStyle || {},
      isIOSStopPasteStyle = false,
      fontElements = [];
  
  
  if (!pEditor.pParent.copyTextStyle)
  {
    copyTextStyle.currentStyle = null;
  }


  this.queryCopyStyleEnabled = () =>
  {
    return true;
  };


  this.queryCopyStyleState = () =>
  {
    return (copyTextStyle.currentStyle != null);
  };


  this.copyStyle = () =>
  {
    const validBlockTag = /(?:P|H[1-6]|BLOCKQUOTE|DIV)/;

    if (copyTextStyle.currentStyle != null)
    {
      copyTextStyle.currentStyle = null;
      return;
    }

    let parentElement = pEditor.helpers.element.getParentElementByTagsNames(null, pEditor.checkAllBlockTags);

    copyTextStyle.currentStyle =
    {
      'blockTag': (parentElement && validBlockTag.test(parentElement.nodeName)) ? parentElement.nodeName : null,
      'cssClass': parentElement ? parentElement.getAttribute('class') : null,
      'fontFamily': pEditor.font.family.getCurrentFullTextFont(),
      'fontSize': pEditor.font.size.getCurrentFontSize(false) + 'px',
      'color': pEditor.font.color.getCurrentForeColor(),
      'backgroundColor': pEditor.font.background.getCurrentBackColor(),
      'fontWeight': pStyle.helpers.getCurrentStyleInRange('fontWeight'),
      'fontStyle': pStyle.helpers.getCurrentStyleInRange('fontStyle'),
      'textDecoration': pStyle.helpers.getCurrentStyleInRange('textDecoration'),
      'textAlign': pStyle.helpers.getCurrentStyleInRange('textAlign'),
      'verticalAlign': pStyle.helpers.getCurrentStyleInRange('verticalAlign')
    };

    copyTextStyle.currentStyle['textDecoration'] = (copyTextStyle.currentStyle['textDecoration'].toLowerCase().indexOf('underline') !== -1) ? 'underline' : '';

    if (BEditor.device.isIOS)
    {
      isIOSStopPasteStyle = true;
      setTimeout(function () { isIOSStopPasteStyle = false; }, 100);
    }
  };


  this.pasteStyle = () =>
  {
    const validBlockTag = /(?:P|H[1-6]|BLOCKQUOTE|DIV)/i;

    let i,
        currentRange,
        currentSelection,
        parentBlockElement,
        str,
        elements,
        keyStyle;

    if (copyTextStyle.currentStyle == null)
    {
      return;
    }

    currentRange = pEditor.range.getCurrent();
    currentSelection = pEditor.range.selection.getCurrent();

    if (currentRange)
    {
      pEditor.range.stopCheckSelection();

      parentBlockElement = pEditor.helpers.element.getParentElementByTagsNames(currentRange, pEditor.checkAllBlockTags);

      if ((BEditor.browser.isIE && ((currentSelection && currentSelection.type && currentSelection.type.toUpperCase() === 'NONE') || currentRange.htmlText === '')) || currentRange.collapsed ||
          (parentBlockElement && (currentRange.startContainer.nodeType !== 3 || currentRange.startOffset === 0) && !pEditor.helpers.element.getPreviousNode(currentRange.startContainer, parentBlockElement) &&
           (currentRange.endContainer.nodeType !== 3 || currentRange.endOffset === currentRange.endContainer.length) && !pEditor.helpers.element.getNextNode(currentRange.endContainer, parentBlockElement)))
      {
        if (parentBlockElement.nodeName === 'BODY')
        {
          copyTextStyle.currentStyle = null;
          return;
        }

        pEditor.contentCleaner.removeStyles(parentBlockElement, copyTextStyle.currentStyle);

        if (copyTextStyle.currentStyle['blockTag'] && validBlockTag.test(parentBlockElement.nodeName))
        {
          if (parentBlockElement.nodeName.toUpperCase() !== copyTextStyle.currentStyle['blockTag'])
          {
            str = parentBlockElement.outerHTML;
            str = str.replace(/^<[A-Z0-9]+([\s>])/i, '<' + copyTextStyle.currentStyle['blockTag'] + ' data-wacopystyleblocktag="1"' + '$1');
            str = str.replace(/<\/[A-Z0-9]+\s*>$/i, '</' + copyTextStyle.currentStyle['blockTag'] + '>');
            parentBlockElement.outerHTML = str;
            parentBlockElement = pEditor.iFrameDoc.body.querySelector('[data-wacopystyleblocktag]');
            parentBlockElement.removeAttribute('data-wacopystyleblocktag');
            pEditor.range.setCursorPoint(parentBlockElement, false);
          }

          if (copyTextStyle.currentStyle['cssClass'])
          {
            parentBlockElement.setAttribute('class', copyTextStyle.currentStyle['cssClass']);
          }
          else
          {
            parentBlockElement.removeAttribute('class');
          }
        }

        for (keyStyle in copyTextStyle.currentStyle)
        {
          if (copyTextStyle.currentStyle.hasOwnProperty(keyStyle) && copyTextStyle.currentStyle[keyStyle] !== BEditor.styleHelpers.getElementStyle(parentBlockElement, keyStyle, pEditor.iFrame))
          {
            if (keyStyle !== 'blockTag')
            {
              parentBlockElement.style[keyStyle] = (copyTextStyle.currentStyle[keyStyle] != null) ? copyTextStyle.currentStyle[keyStyle] : '';
            }
          }
        }
      }
      else
      {
        if (!BEditor.browser.isIE)
        {
          pEditor.iFrameDoc.execCommand('styleWithCSS', false, false);
        }

        collectExistingFontElements();
        pEditor.iFrameDoc.execCommand('fontname', false, 'WaFontMarkTag');

        elements = pEditor.iFrameDoc.body.querySelectorAll('FONT[face*=WaFontMarkTag]');

        for (i = elements.length; i--;)
        {
          pEditor.contentCleaner.removeStyles(elements[i], copyTextStyle.currentStyle);

          for (keyStyle in copyTextStyle.currentStyle)
          {
            if (copyTextStyle.currentStyle.hasOwnProperty(keyStyle))
            {
              if (keyStyle !== 'blockTag' && copyTextStyle.currentStyle[keyStyle] !== BEditor.styleHelpers.getElementStyle(elements[i], keyStyle, pEditor.iFrame))
              {
                elements[i].style[keyStyle] = (copyTextStyle.currentStyle[keyStyle] != null) ? copyTextStyle.currentStyle[keyStyle] : '';
              }
            }
          }
        }
      }

      restoreExistingFontElements();
      copyTextStyle.currentStyle = null;
      pStyle.justifier.webKitNormalizeJustify();
    }

    pEditor.range.restoreBookmark();
  };


  function collectExistingFontElements ()
  {
    const elements = pEditor.iFrameDoc.body.getElementsByTagName('FONT');

    fontElements.splice(0, fontElements.length);

    if (elements && elements.length)
    {
      for (let i = elements.length; i--;)
      {
        elements[i].setAttribute('data-wafontindex', i);

        fontElements[i] =
        {
          'face': elements[i].getAttribute('face')
        };
      }
    }
  }


  function restoreExistingFontElements ()
  {
    const elements = pEditor.iFrameDoc.body.querySelectorAll('FONT[face*=WaFontMarkTag]');

    var  waFontIndex;


    for (let i = elements.length; i--;)
    {
      waFontIndex = parseInt(elements[i].getAttribute('data-wafontindex'), 10);

      if (!isNaN(waFontIndex) && fontElements[waFontIndex].face && fontElements[waFontIndex].face !== 'WaFontMarkTag')
      {
        elements[i].setAttribute('face', fontElements[waFontIndex].face);
      }
      else if (elements[i].getAttribute('face').indexOf('WaFontMarkTag') !== -1)
      {
        elements[i].removeAttribute('face');
      }
    }

    removeExistingFontElementsAttribute();
  }


  function removeExistingFontElementsAttribute ()
  {
    const elements = pEditor.iFrameDoc.body.querySelectorAll('[data-wafontindex]');

    for (let i = elements.length; i--;)
    {
      elements[i].removeAttribute('data-wafontindex');
    }

    fontElements.splice(0, fontElements.length);
  }
  
  
  Object.defineProperty(this, 'copyTextStyle', { get: () => copyTextStyle });
  Object.defineProperty(this, 'isIOSStopPasteStyle', { get: () => isIOSStopPasteStyle });
}